<template>
  <a-info-validation
    :hint="hint"
    :error-messages="errorMessages"
    control-class="text-input-container"
  >
    <div class="input-group">
      <input
        :id="id"
        :type="type"
        :name="id"
        :value="text"
        :placeholder="placeholder"
        class="form-control"
        :class="{ 'is-invalid': errorMessages.length }"
        @input="$emit('input', $event.target.value)"
      />
      <div v-if="iconClass" class="input-group-append">
        <button
          class="input-group-text"
          type="button"
          @click="$emit('icon-clicked')"
        >
          <i class="icon fa" :class="iconClass" />
        </button>
      </div>
    </div>
  </a-info-validation>
</template>

<script>
import InfoValidation from "+/components/form/infoValidation/InfoValidation";
import uniqid from "uniqid";

export default {
  components: {
    "a-info-validation": InfoValidation
  },
  model: {
    prop: "text",
    event: "input"
  },
  props: {
    text: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: () => uniqid("text-input-")
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: ""
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    iconClass: {
      type: String,
      default: ""
    }
  }
};
</script>
